/* eslint-disable import/no-unresolved */
// import 'server-only';
// import APICONSTANT from '@/services/config';
// import FalbackTranslate from './fallback_translate';
// import FallbackTranslate from './fallbacktranslate'
import { axios } from '../axios';
import { getCookie } from '../cookies';

export const getDictionary = async () => {
  try {
    const lang = getCookie("NEXT_LOCALE") || 'en'; // Cookie value
    const response = await axios.get(`public/locale/${lang}.json`);
    return response?.data || {};
  } catch (err) {
    return {};
  }
};
